function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import { Uppy } from '@uppy/core';
import { DragDrop, useUppy } from '@uppy/react';
import classNames from 'classnames';
import { Form, Formik } from 'formik';
import React, { useReducer } from 'react';
import { FormLabel } from 'react-bootstrap';
import { useMount } from 'react-use';
import { boolean, object, string } from 'yup';
import text from '../../../text';
import { getUser } from '../../../utilities/storage';
import { Button } from '../../button';
import Checkbox from '../../form/Checkbox';
import Control from '../../form/Control';
import { File } from './file';
import { initialState, uploadAssetActions, uploadAssetReducer } from './reducer';
import { client } from '../../../utilities/api';
import { ACTIVITY_TYPES } from '../../../constants/activity';
var uploadFilesSchema = object().shape({
    description: string(),
    sendNotification: boolean()
});
var initialValues = {
    description: '',
    sendNotification: false
};
export var UploadAssetForm = function(param) {
    var projectId = param.projectId, onSubmit = param.onSubmit, onCancel = param.onCancel;
    var _useReducer = _sliced_to_array(useReducer(uploadAssetReducer, initialState), 2), _useReducer_ = _useReducer[0], files = _useReducer_.files, uploading = _useReducer_.uploading, error = _useReducer_.error, dispatch = _useReducer[1];
    var uppy = useUppy(function() {
        var newUppy = new Uppy({
            debug: process.env.NODE_ENV === 'development'
        }).use(AwsS3Multipart, {
            limit: 5,
            companionUrl: process.env.UPPY_COMPANION_URL,
            companionHeaders: {
                Authorization: "Bearer ".concat(getUser().token)
            },
            createMultipartUpload: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(file) {
                    var data;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    client.createProjectAsset(projectId, file.name, file.type)
                                ];
                            case 1:
                                data = _state.sent().data;
                                file.meta['assetId'] = data.asset_id;
                                return [
                                    2,
                                    this.createMultipartUpload(file)
                                ];
                        }
                    });
                });
                return function(file) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
        newUppy.on('file-added', function(file) {
            dispatch(uploadAssetActions.addFile({
                id: file.id,
                name: file.name,
                type: file.type
            }));
        }).on('file-removed', function(file) {
            dispatch(uploadAssetActions.removeFile(file.id));
        }).on('upload-progress', function(file, progress) {
            dispatch(uploadAssetActions.updateProgress({
                id: file.id,
                progress: progress.bytesUploaded / progress.bytesTotal * 100
            }));
        }).on('upload', function() {
            dispatch(uploadAssetActions.setUploading(true));
            dispatch(uploadAssetActions.setError(null));
        }).on('error', function(error) {
            dispatch(uploadAssetActions.setError(error));
            dispatch(uploadAssetActions.setUploading(false));
        }).on('upload-error', function(file, error, response) {
            dispatch(uploadAssetActions.setError(error));
            dispatch(uploadAssetActions.setUploading(false));
            newUppy.reset();
        });
        return newUppy;
    });
    useMount(function() {
        return function() {
            uppy.cancelAll();
        };
    });
    var onHandleCancel = function(event) {
        event.preventDefault();
        uppy.cancelAll();
        onCancel();
    };
    var onHandleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var uploadResult, promises, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            uppy.upload()
                        ];
                    case 1:
                        uploadResult = _state.sent();
                        if (!((uploadResult === null || uploadResult === void 0 ? void 0 : uploadResult.successful.length) > 0)) return [
                            3,
                            4
                        ];
                        promises = uploadResult.successful.map(function(file) {
                            return client.commitProjectAsset(projectId, file.meta.assetId);
                        });
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            client.createActivity(projectId, _object_spread({
                                type: ACTIVITY_TYPES.file,
                                title: 'Files to download',
                                createdAssetIds: uploadResult.successful.map(function(file) {
                                    return file.meta.assetId;
                                })
                            }, values))
                        ];
                    case 3:
                        _state.sent();
                        onSubmit();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        dispatch(uploadAssetActions.setError(error));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onHandleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var onRemoveFile = function(id) {
        if (!uploading) {
            uppy.removeFile(id);
        }
    };
    return /*#__PURE__*/ React.createElement(Formik, {
        initialValues: initialValues,
        validationSchema: uploadFilesSchema,
        onSubmit: onHandleSubmit
    }, function(param) {
        var handleChange = param.handleChange, handleBlur = param.handleBlur, isValid = param.isValid, values = param.values, errors = param.errors, touched = param.touched;
        return /*#__PURE__*/ React.createElement(Form, {
            noValidate: true
        }, /*#__PURE__*/ React.createElement(Control, {
            label: text('note'),
            as: "textarea",
            type: "text",
            name: "description",
            isFailed: touched.description && !!errors.description,
            value: (values === null || values === void 0 ? void 0 : values.description) || '',
            onBlur: handleBlur,
            onChange: handleChange,
            placeholder: text('enterNote'),
            validationError: touched.description && errors.description,
            autoComplete: "off",
            disabled: uploading
        }), /*#__PURE__*/ React.createElement(FormLabel, {
            className: "Control-Label"
        }, text('files')), /*#__PURE__*/ React.createElement("div", {
            className: classNames('asset-uploader', {
                disabled: uploading,
                error: error
            })
        }, /*#__PURE__*/ React.createElement(DragDrop, {
            uppy: uppy,
            note: text('dropFilesToUpload'),
            locale: {
                strings: {
                    dropHereOr: text('dropHereOr'),
                    browse: text('browseToUpload')
                }
            }
        }), error && /*#__PURE__*/ React.createElement("p", {
            className: "Control-Feedback isFailed"
        }, error.message)), files.ids.map(function(id) {
            return /*#__PURE__*/ React.createElement(File, {
                key: id,
                file: files.entities[id],
                onRemove: onRemoveFile,
                uploading: uploading
            });
        }), /*#__PURE__*/ React.createElement(Checkbox, {
            id: "sendNotification",
            onChange: handleChange,
            name: "sendNotification",
            value: values === null || values === void 0 ? void 0 : values.sendNotification,
            label: text('sendNotificationToCustomer'),
            disabled: uploading
        }), /*#__PURE__*/ React.createElement("div", {
            className: "form-footer"
        }, /*#__PURE__*/ React.createElement(Button, {
            type: "submit",
            disabled: !isValid || uploading || files.ids.length === 0
        }, text('upload')), /*#__PURE__*/ React.createElement("a", {
            name: "cancel",
            href: "#",
            onClick: onHandleCancel
        }, text('cancel'))));
    });
};
